import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { PaginatorState } from "primeng/paginator";
import {
  catchError,
  combineLatest,
  finalize,
  of,
  startWith,
  Subject,
  switchMap,
  tap,
} from "rxjs";
import { TransfersService } from "../../../services/transfers.service";
import { TransferInvitationsListComponent } from "./transfer-invitations-list/transfer-invitations-list.component";

@Component({
    selector: "app-transfer-invitations-tab",
    imports: [CommonModule, TransferInvitationsListComponent],
    templateUrl: "./transfer-invitations-tab.component.html",
    styleUrl: "./transfer-invitations-tab.component.scss"
})
export class TransferInvitationsTabComponent {
  private readonly transferService = inject(TransfersService);

  private readonly page$ = new Subject<PaginatorState | undefined>();
  private readonly refreshInvitations$ = new Subject<void>();
  isLoading = false;

  myInvitations$ = combineLatest([
    this.page$.pipe(startWith(undefined)),
    this.refreshInvitations$.pipe(startWith(null)),
  ]).pipe(
    switchMap(([page]) =>
      this.transferService
        .getReceivedTransfers(page)
        .pipe(finalize(() => (this.isLoading = false))),
    ),
  );

  handleAcceptInvitationClick(invitation_id: number) {
    this.isLoading = true;
    this.transferService
      .acceptTransfer(invitation_id)
      .pipe(
        tap(() => this.refreshInvitations$.next()),
        catchError(() => {
          this.isLoading = false;
          return of(null);
        }),
      )
      .subscribe();
  }

  handleDeclineInvitationClick(invitation_id: number) {
    this.isLoading = true;
    this.transferService
      .declineTransfer(invitation_id)
      .pipe(
        tap(() => this.refreshInvitations$.next()),
        catchError(() => {
          this.isLoading = false;
          return of(null);
        }),
      )
      .subscribe();
  }

  handlePageChange(page: PaginatorState) {
    this.page$.next(page);
  }
}
